import { Component, Inject, OnInit, TemplateRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';

import { AlertComponent } from 'ngx-bootstrap/alert';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SESSION_STORAGE, WebStorageService } from 'ngx-webstorage-service';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { PreIronedFacade } from '../../../common/facade/PreIronedFacade';
import { StoreFacade } from '../../../common/facade/StoreFacade';
import { Strings } from '../../../common/language/strings';
import { res } from '../../../common/language/text/res';
import { PreIroned } from '../../../common/model/PreIroned';
import { PreIronedDetail } from '../../../common/model/PreIronedDetail';
import { Permissions } from '../../../common/model/dictionary/Permissions'
import { PreIronedFailure } from '../../../common/model/PreIronedFailure';
import { PreIronedInRevision } from '../../../common/model/PreIronedInRevision';

@Component({
  selector: 'app-inventory-preironed',
  templateUrl: './inventory-preironed.component.html',
  styleUrls: ['./inventory-preironed.component.css']
})
export class InventoryPreironedComponent implements OnInit {

  public res = res;
  titlePreIroned = res.PreIroned;
  lblStore = res.Store;
  lblInitDate = res.StartDate;
  lblFinalDate = res.EndDate;
  lblLoadFile = res.AlertUploadedFile;
  lblProcess = res.Process;
  lblBtnDetail = res.GenerateDetail;
  lblTheoreticalFile = res.TheoreticalFile
  lblReturn = res.Return;
  lblChargeEntry = res.ChargeEntry;
  lblSales = res.Sales;
  lblIncomeCommodity = res.WareEntry;
  lblEndInventory = res.EndingTheoreticalInventory;
  lblBtnDownload = res.Download;
  lblConcept = res.Concept;
  lblSummary = res.Summary;
  lblInfo = res.TitleInfo;
  lblTotal = res.Total;
  lblSelectAFile = res.SelectAFile;
  lblUnassigned = res.Unassigned;
  lblSelectAnOption = res.SelectAnOption;
  lblChoose = res.Choose;
  lblDate = res.Date;
  lblSKU = res.SKU;
  lblDetail = res.Detail;
  lblFailures = res.Failures;
  lblFailureDate = res.FailureDate;
  lblFailureType = res.FailureType;
  lblStoreCharge = res.StoreCharge;
  lblFactoryCharge = res.FactoryCharge;
  lblInventory = res.Inventory;
  lblRegularization = res.Regularization;

  isSpanish = true;
  loading = false;
  messagesTable: any = {
    emptyMessage: '',
    totalMessage: ''
  };

  stores = [];
  summary: PreIroned[] = [];
  details: PreIronedDetail[] = [];
  detailsFile: PreIronedDetail[] = [];
  detailsFailures: PreIronedFailure[] = [];
  detailsDowload: PreIronedDetail[] = [];
  inRevision = new PreIronedInRevision();

  alertModal: any[] = [];
  permissionsList: any[] = [];
  store = -1;

  totalReturn = 0;
  totalChargeEntry = 0;
  totalWareEntry = 0;
  totalSales = 0;
  totalFile = 0;
  totalStoreCharge = 0;
  totalFactoryCharge = 0;
  totalInventory = 0;
  totalRegularization = 0;
  totalTheoretical = 0;

  messageLoader = '';
  file: any;
  statusProceso = -1;
  lblStatus = res.WithoutProcess;
  oldStore = '';
  changeDate = false;

  fileUrl: any;
  fileName: any;

  ModalStore: BsModalRef;
  config = {
    ignoreBackdropClick: true
  };

  visibleRead = false;
  visibleLoad = false;
  visibleDownload = false;
  detialCharged = false;
  fileCharged = false;
  changeFile = false;

  visibleReturn = false;
  visibleWareEntry = false;
  visibleSales = false;
  visibleEntryCharge = false;
  visibleStoreCharge = false;
  visibleFactoryCharge = false;
  visibleInventory = false;
  visibleRegularization = false;

  public txtMinDate = new Date(this.getNowUTC().getFullYear() - 1,
    this.getNowUTC().getMonth(),
    1,
    this.getNowUTC().getHours(),
    this.getNowUTC().getMinutes(),
    this.getNowUTC().getSeconds(),
    this.getNowUTC().getMilliseconds());

  public txtMaxDate = new Date();
  public txtStartDate = new Date();
  public txtEndDate = new Date();

  constructor(
    @Inject(SESSION_STORAGE) private _storage: WebStorageService,
    public strings: Strings,
    private _facadeStore: StoreFacade,
    private _facadeIroned: PreIronedFacade,
    private _route: ActivatedRoute,
    private modalService: BsModalService,
    private localeService: BsLocaleService) { }

  ngOnInit(): void {
    this.isSpanish = this.strings.getLanguageIsSpanish();
    this.localeService.use(this.strings.getLanguage());

    this.messagesTable.emptyMessage = this.strings.GetText(res.ThereIsNoInformation);
    this.messagesTable.totalMessage = 'Total';
    this._route.queryParams.subscribe(params => {
      if (params['startDate'] !== undefined && params['endDate'] !== undefined) {
        this.txtStartDate = params['startDate'];
        this.txtEndDate = params['endDate'];
        this.txtMaxDate = params['endDate'];
        this.getStores();
      } else {
        this.getStores();
      }
    });

    this.validatePermissions();
  }

  onStoreChange() {
    const storeSelect = document.querySelector('#storeSelect') as HTMLSelectElement;
    const selectedStoreName = storeSelect.options[storeSelect.selectedIndex].text;

    if (this.store != -1) {
      if (!(this.statusProceso == 1 && selectedStoreName != this.oldStore)) {
        this.statusProceso = -1;
        this.lblStatus = res.WithoutProcess;
      }

      this.oldStore = selectedStoreName;
      this.getSummary(this.txtStartDate, this.txtEndDate, this.store.toString());
    }
  }

  private getNowUTC() {
    const now = new Date();
    return new Date(now.getTime() + (now.getTimezoneOffset() * 60000));
  }

  private getStores() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);
    this._facadeStore.GetParticipateQuantum().subscribe(
      response => {
        this.stores = response.data;
      }, error => {
        this.loading = false;
        this.addAlertModal('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertStoresCouldNotBeObtained), 'danger');
      }
    );
    this.loading = false;
  }

  fileChanged(event) {
    this.file = event.target.files[0];

    this.changeFile = this.fileName != event.target.files[0].name;

    if (this.changeFile) {
      this.detailsFailures = [];
      this.details = [];
    }

    this.fileName = event.target.files[0].name;

    this.uploadNotificationFile(this.file);

    // Actualizar el texto del elemento label con el nombre del archivo
    const label = document.querySelector('.custom-file-label');
    label.textContent = this.fileName;
  }

  uploadNotificationFile(document) {
    this.loading = true
    let reader = new FileReader();
    this.inRevision.material = [];
    let namefile = document.name.split('.')
    let extension = namefile[1];
    this.detailsFile = [];

    if (extension == "txt") {

      this.totalFile = 0;

      reader.onload = (e) => {
        const records = reader.result as string;
        let withoutJumps = records.split('\n');


        withoutJumps.forEach(line => {
          const item = line.split(',');

          if (item.length >= 2 && !isNaN(parseInt(item[1]))) {
            let detail = new PreIronedDetail;

            detail.concept = this.strings.GetText(this.lblLoadFile);
            detail.sku = item[0];
            detail.date = this.getNowUTC().toLocaleDateString();
            detail.total = parseInt(item[1]);
            detail.storeName = "";

            this.detailsFile.push(detail);

            this.totalFile = this.totalFile + parseInt(item[1]);
            this.doTotalized();
            this.statusProceso = 1
            this.lblStatus = res.Completed;
          }
        });

        if (this.detailsFile.length > 0) {
          this.inRevision.finalDate = this.txtEndDate;
          this.inRevision.initialDate = this.txtStartDate;
          this.inRevision.storeId = this.store.toString();

          this.detailsFile.forEach(item => {
            this.inRevision.material.push(`${item.sku},${item.total}`);
          });
        }
      }

      this.fileCharged = true;
    }
    else {
      this.statusProceso = 0;
      this.lblStatus = res.WithError;
      this.loading = false;
      this.addAlertModal('<strong>¡Error!</strong> ' + this.strings.GetText(res.FileTypeNoSupported), 'danger');
    }

    reader.readAsText(document)
    this.loading = false;
  }

  getSummary(initialDate: Date, finalDate: Date, storeSelected: string) {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);

    this.totalChargeEntry = 0;
    this.totalReturn = 0;
    this.totalSales = 0;
    this.totalWareEntry = 0;
    this.totalFactoryCharge = 0;
    this.totalInventory = 0;
    this.totalStoreCharge = 0;
    this.totalRegularization = 0;

    if (storeSelected !== '-1') {
      this._facadeIroned.GetInventorySummary(initialDate, finalDate, storeSelected).subscribe(
        respose => {
          this.summary = respose.data;

          if (!isNullOrUndefined(this.summary)) {
            this.summary.forEach(element => {
              switch (element.concept) {
                case MOVEMENTS.RETURN:
                  this.totalReturn = element.total;
                  break;
                case MOVEMENTS.RECTIFIED_CHARGE_ENTRY:
                case MOVEMENTS.CHARGE_ENTRY:
                  this.totalChargeEntry += element.total;
                  break;
                case MOVEMENTS.WARE_ENTRY:
                  this.totalWareEntry = element.total;
                  break;
                case MOVEMENTS.SALE:
                  this.totalSales = element.total;
                  break;
                case MOVEMENTS.FACTORY_CHARGE:
                  this.totalFactoryCharge = element.total;
                  break;
                case MOVEMENTS.RECTIFIED_CHARGE:
                case MOVEMENTS.STORE_CHARGE:
                  this.totalStoreCharge += element.total;
                  break;
                case MOVEMENTS.INVENTORY:
                  this.totalInventory = element.total;
                  break;
                case MOVEMENTS.REGULARIZATION:
                  this.totalRegularization = element.total;
                  break;
              }
            })

            this.visibleEntryCharge = this.totalChargeEntry != 0;
            this.visibleReturn = this.totalReturn != 0;
            this.visibleWareEntry = this.totalWareEntry != 0;
            this.visibleSales = this.totalSales != 0;
            this.visibleStoreCharge = this.totalStoreCharge != 0;
            this.visibleFactoryCharge = this.totalFactoryCharge != 0;
            this.visibleInventory = this.totalInventory != 0;
            this.visibleRegularization = this.totalRegularization != 0;

            this.doTotalized();
          }
          this.loading = false;
        }, error => {
          this.loading = false;
          this.addAlertModal('<strong>¡Error!</strong> ' + error, 'danger');
        });
    }
  }

  getDetails() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);

    if (this.details.length <= 0 && !this.fileCharged) {
      this.addAlertModal('<strong>¡Error!</strong> ' + this.strings.GetText(res.NoFileCharged), 'danger');
      this.loading = false;
      return;
    }

    if (this.details.length > 0 && this.detialCharged) {
      this.loading = false;
      return;
    }

    this.details = []

    this._facadeIroned.GetInventoryDetails(this.inRevision).subscribe(
      respose => {
        if (respose.completed) {
          this.details = respose.data;

          this.details.forEach(detail => {
            let dates = detail.date.split('T');
            const date = new Date(dates[0]);

            const day = (date.getDate() + 1).toString().padStart(2, "0");
            const month = (date.getMonth() + 1).toString().padStart(2, "0");
            const year = date.getFullYear().toString();
            const formattedDate = `${day}/${month}/${year}`;

            detail.date = formattedDate;

            if (isNullOrUndefined(detail.wareHouse) || detail.wareHouse == '') {
              this.fileName = detail.sap + '_';
            }
            else {
              this.fileName = detail.sap + '_' + detail.wareHouse + '_';
            }
          });

          this.detialCharged = true;
        }
        else {
          console.log(respose.message);
          this.addAlertModal(this.strings.GetText(res.ThereIsNoInformation), 'warning');
        }

        this.loading = false;
      }, error => {
        this.loading = false;
        console.log(error);
        this.addAlertModal('<strong>¡Error!</strong> ' + error, 'danger');
      }
    );
  }

  getFailures() {
    this.loading = true;
    this.messageLoader = this.strings.GetText(res.Loading);

    if (this.details.length == 0) {
      this.loading = false;
      this.addAlertModal('<strong>¡Error!</strong> ' + this.strings.GetText(res.ErrorMessageGenerateDetails), 'danger');
    }

    this.detailsFailures = [];

    this._facadeIroned.GetInventoryFailures(this.store).subscribe(response => {
      this.detailsFailures = response.data;

      this.detailsFailures.forEach(detail => {
        let dates = detail.failureDate.split('T');
        const date = new Date(dates[0]);

        const day = (date.getDate() + 1).toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear().toString();
        const formattedDate = `${day}/${month}/${year}`;

        detail.failureDate = formattedDate;
      });

      this.changeDate = false;
      this.loading = false;
    }, error => {
      this.loading = false;
      console.log(error);
      this.addAlertModal('<strong>¡Error!</strong> ' + error, 'danger');
    });
  }

  downloadFile() {
    this.loading = true;
    let fileContent = '';
    const date = new Date();
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString();

    if (this.details.length == 0) {
      this.loading = false;
      this.addAlertModal('<strong>¡Error!</strong> ' + this.strings.GetText(res.AlertNoInfoToDownload), 'danger');
      return;
    }

    if (this.detailsFailures.length > 0) {
      this.loading = false;
      this.addAlertModal('<strong>' + this.strings.GetText(res.ThereAreErrorNoDownload) + '</strong>', 'warning');
      return;
    }

    this._facadeIroned.GetInventoryToDownload(this.store).subscribe(response => {
      this.detailsDowload = response.data;

      this.detailsDowload.forEach(detail => {
        if (detail.total != 0 && detail.total > 0) {
          fileContent += `${detail.sku},${detail.total}\n`;
        }
      });

      const blob = new Blob([fileContent], { type: 'text/plain' });
      this.fileUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      let yearString = year.substr(-2, 2);

      let nameFile = this.fileName.split('.');

      if (isNullOrUndefined(nameFile[1])) {
        this.fileName += `${yearString}${month}${day}.txt`;
      }

      link.href = this.fileUrl;
      link.download = this.fileName;
      link.click();
      this.loading = false;

    }), error => {
      this.loading = false;
      console.log(error);
      this.addAlertModal('<strong>¡Error!</strong> ' + error, 'danger');
    };
  }

  onChangeStartDate(value) {
    value = this.subtractTimeFromDate(value, 6);
    this.txtStartDate = value;

    if (this.store != -1) {
      if (this.txtStartDate <= this.txtEndDate) {
        this.getSummary(this.txtStartDate, this.txtEndDate, this.store.toString());
      }
      else {
        this.addAlertModal('<strong>!Error¡ ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger')
      }
    }
    this.changeDate = true;
    this.detialCharged = false;
  }

  onChangeEndDate(value) {
    value = this.subtractTimeFromDate(value, 6);
    this.txtEndDate = value;

    if (this.store != -1) {
      if (this.txtEndDate >= this.txtStartDate) {
        this.getSummary(this.txtStartDate, this.txtEndDate, this.store.toString());
      }
      else {
        this.addAlertModal('<strong>!Error¡ ' + this.strings.GetText(res.AlertTheStartDateCannotBeHigher), 'danger')
      }
    }
    this.changeDate = true;
    this.detialCharged = false;
  }

  openModalDetails(template: TemplateRef<any>) {
    this.getDetails();

    this.ModalStore = this.modalService.show(
      template,
      Object.assign({},
        { class: 'gray modal-xl' },
        this.config)
    )
  }

  openModalFailures(template: TemplateRef<any>) {
    this.getFailures();

    this.ModalStore = this.modalService.show(
      template,
      Object.assign({},
        { class: 'gray modal-xl' },
        this.config)
    )
  }

  closeModal() {
    this.modalService.hide();
  }

  doTotalized() {
    this.totalTheoretical = this.totalFile
      + this.totalFactoryCharge
      + this.totalStoreCharge
      + this.totalReturn
      + this.totalChargeEntry
      + this.totalSales
      + this.totalWareEntry
      + this.totalInventory
      + this.totalRegularization;
  }

  addAlertModal(message: String, type: String): void {
    this.alertModal.push({
      type: type,
      msg: message,
      timeout: 5000
    });
  }

  onClosed(dismissedAlert: AlertComponent) {
    this.alertModal = this.alertModal.filter(alert => alert !== dismissedAlert);
  }

  validatePermissions() {
    this.permissionsList = this._storage.get('permissions')

    this.permissionsList.forEach(element => {
      if (element.name == Permissions.PreIronedLoad) {
        this.visibleLoad = true;
      }
    });

    this.permissionsList.forEach(element => {
      if (element.name == Permissions.PreIronedRead) {
        this.visibleRead = true;
      }
    });

    this.permissionsList.forEach(element => {
      if (element.name == Permissions.PreIronedDownload) {
        this.visibleDownload = true;
      }
    });
  }

  subtractTimeFromDate(objDate, intHours) {
    var numberOfMlSeconds = objDate.getTime();
    var addMlSeconds = (intHours * 60) * 60000;
    var newDateObj = new Date(numberOfMlSeconds - addMlSeconds);
    return newDateObj;
  }
}

export const MOVEMENTS = {
  RETURN: "Devolución",
  RECTIFIED_CHARGE_ENTRY: "Ent.Cargo(rectif.)",
  CHARGE_ENTRY: "Entrada de Cargo",
  WARE_ENTRY: "IngresoDeMercancia",
  SALE: "Venta",
  FACTORY_CHARGE: "Cargo Fabrica",
  RECTIFIED_CHARGE: "Cargo(rectif.)",
  STORE_CHARGE: "Cargo Tienda",
  INVENTORY: "Inventario",
  REGULARIZATION: "Regularizacion"
}